import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Profile from "../utils/Profile";
import profileAction from "./../../redux/profile/actions";
import dashboardActions from "../../redux/dashboard/actions";
import authActions from "../../redux/auth/actions";
import Modal from "../utils/Model";
import Button from "../utils/Button";
import { isAdmin, isAdminAgent, formatDigits } from "../../helpers/commonFunction";
import Loader from "../utils/Loader";
import useSocket from '../../hooks/useSocket';
import moment from "moment-timezone";

const { openEditProfileModel, openChangePasswordModel } = profileAction;
const { getUserDataByToken, logout: logoutAction } = authActions;
const { openJarStatusModel, closeJarStatusModel, jarRunningStatus, getBoomData, openISPJarStatusModel, closeISPJarStatusModel, updateIspJarRunningStatus } = dashboardActions;

function Header() {
  const dispatch = useDispatch();
  const [accountBalance, setAccountBalance] = useState(0);
  const profileList = useSelector((state) => state.profile.profileListResult);
  const { tokenData, logoutLoading, logoutMessage, loading: getUserByTokenLoading } = useSelector((state) => state.auth);
  const { showJarStatusModal, getBoomDataList, getBoomDataLoading, showISPJarStatusModal, ispJarLoading, jarStatusLoading } = useSelector((state) => state.dashboard);
  const { activationRequestResult } = useSelector((state) => state.activationRequest);
  const [switchAction, setSwitchAction] = useState(false);
  const [switchISPAction, setSwitchISPAction] = useState(false);
  const [laTime, setLaTime] = useState(moment().tz(`${process.env.REACT_APP_DISPLAY_TIMEZONE}`).format(`${process.env.REACT_APP_LONG_TIME_FORMAT}`));

  const { register, handleSubmit, watch, formState: { errors }, reset, } = useForm({});
  const { register: registerform, handleSubmit: handleISPSubmit, formState: { errorsform }, } = useForm({});

  useEffect(() => {
    dispatch(getUserDataByToken());
  }, []);

  useSocket("manual add fund", () => {
    dispatch(getUserDataByToken());
  });

  useSocket("delete user", (data) => {
    if (tokenData && tokenData[0].ID == data.userId && data.status == 0) {
      handleSignOut();
    }
  });

  useSocket("delete dealer", (data) => {
    if (tokenData && tokenData[0].DealerID == data.dealerId && data.status == 0) {
      handleSignOut();
    }
  });

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        localStorage.setItem("version_code", data.VersionCode);
        setAccountBalance(data.AccountBalance);
        setSwitchAction(data.JARFlag === 1 ? true : false);
        setSwitchISPAction(data.ISPJARFlag === 1 ? true : false);
      });

    // if (tokenData && tokenData.length > 0 && isAdmin(tokenData)) {
    //   dispatch(getBoomData());
    // }

  }, [tokenData, activationRequestResult]);

  const isAdminUser = useMemo(() => {
    return tokenData && tokenData.length > 0 && isAdmin(tokenData);
  }, [tokenData]);

  useEffect(() => {
    if (isAdminUser) {
      dispatch(getBoomData());
    }
  }, [isAdminUser]);



  const handleEditProfileModel = () => {
    dispatch(openEditProfileModel());
  };

  const handleChangePassword = () => {
    dispatch(openChangePasswordModel());
  };

  useEffect(() => {
    if (logoutMessage) {
      localStorage.clear();
      window.location.href = "/sign-in";
    }
  }, [logoutMessage]);

  const handleSignOut = () => {
    sessionStorage.clear();
    let tok = localStorage.getItem('mvno_admin_token');
    dispatch(logoutAction({
      token: tok
    }));
  };

  const switchHandler = (item) => {
    dispatch(openJarStatusModel());
  };
  const closeNetworkModal = () => {
    dispatch(closeJarStatusModel());
  };

  const onSubmit = () => {
    dispatch(closeJarStatusModel());
    const data = {
      UpdatedStatus: switchAction == true ? 0 : 1,
    };
    dispatch(jarRunningStatus(data));
    setSwitchAction((pre) => !pre);
  };

  const switchHandlerForISp = () => {
    dispatch(openISPJarStatusModel());
  };

  const closeISPJarModal = () => {
    dispatch(closeISPJarStatusModel());
  };

  const onISPSubmit = () => {
    dispatch(closeISPJarStatusModel());
    const data = {
      UpdatedStatus: switchISPAction == true ? 0 : 1,
    };
    dispatch(updateIspJarRunningStatus(data));
    setSwitchISPAction((pre) => !pre);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setLaTime(moment().tz(`${process.env.REACT_APP_DISPLAY_TIMEZONE}`).format(`${process.env.REACT_APP_LONG_TIME_FORMAT}`));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {getUserByTokenLoading && <Loader />}
      <div class="iq-top-navbar">
        <div class="iq-navbar-custom">
          <div class="iq-sidebar-logo">
            <div class="top-logo">
              <a href="index.html" class="logo">
                <img src="images/logo.gif" class="img-fluid" alt="" />
                <span>MVNO Wireless</span>
              </a>
            </div>
          </div>
          <nav class="navbar navbar-expand-lg navbar-light p-0">
            <button class="navbar-toggler collapsed mr-3" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-label="Toggle navigation" aria-expanded="false">
              <i class="ri-menu-3-line"></i>
            </button>
            <div class="iq-menu-bt align-self-center">
              <div class="wrapper-menu">
                <div class="main-circle"><i class="ri-arrow-left-s-line"></i></div>
                <div class="hover-circle"><i class="ri-arrow-right-s-line"></i></div>
              </div>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto navbar-list">
                <li className="nav-item">
                  <div className="text-primary font-weight-bold" style={{ marginRight: '15px', marginTop: '24px', paddingLeft: '10px' }}>
                    EST Time: {laTime}
                  </div>
                </li>
                {/* <li class="nav-item switchClass">
                  {(tokenData && isAdmin(tokenData) || (isAdminAgent(tokenData))) && 
                  <div class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color pt-1">
                    <p className="mb-0 pr-1 text-dark font-weight-bold" > ISP Bot Status: </p>
                    <div style={{ display: "flex", justifyContent: "center", cursor: "pointer", }} >
                      <div onClick={switchHandlerForISp} style={{ border: "1px solid gray", height: "30px", width: "60px", borderRadius: "30px", display: "flex", }} >
                        {switchISPAction == true ? (
                          <div style={{ backgroundColor: "#de0a0a", height: "20px", width: "20px", borderRadius: "20px", margin: "5px 3px 5px 35px", }} ></div>
                        ) : (
                          <div style={{ backgroundColor: "gray", height: "20px", width: "20px", borderRadius: "20px", margin: "5px", }} ></div>
                        )}
                      </div>
                    </div>
                  </div>}
                </li> */}

                <li class="nav-item switchClass">
                  {tokenData && isAdmin(tokenData) && <div class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color pt-1">
                    <p className="mb-0 pr-1 text-dark font-weight-bold" >
                      Bot Status:
                    </p>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        onClick={switchHandler}
                        style={{
                          border: "1px solid gray",
                          height: "30px",
                          width: "60px",
                          borderRadius: "30px",
                          display: "flex",
                        }}
                      >
                        {switchAction == true ? (
                          <div
                            style={{
                              backgroundColor: "#27b345",
                              height: "20px",
                              width: "20px",
                              borderRadius: "20px",
                              margin: "5px 3px 5px 35px",
                            }}
                          ></div>
                        ) : (
                          <div
                            style={{
                              backgroundColor: "gray",
                              height: "20px",
                              width: "20px",
                              borderRadius: "20px",
                              margin: "5px",
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>}
                </li>

                <li class="nav-item">
                  <a href="#" class="search-toggle iq-waves-effect text-center">
                    <span className={`text-primary font-weight-bold`} style={{ lineHeight: !isAdmin(tokenData) ? '70px' : '' }}>
                      {" "} {Number(accountBalance) < 0 ? `$(${formatDigits(Number(Math.abs(accountBalance)).toFixed(2))})` : `$${formatDigits(Number(accountBalance).toFixed(2))}`}
                    </span>
                    {
                      isAdmin(tokenData) &&
                      <>
                        <hr className="my-0" />
                        <span className="text-success font-weight-bold">
                          POS {getBoomDataList.WalletBalance && `$${formatDigits(getBoomDataList.WalletBalance)}`}
                        </span>
                      </>
                    }

                  </a>
                </li>
              </ul>
            </div>

            <ul class="navbar-list">
              <li>
                <a
                  href="#"
                  className="search-toggle iq-waves-effect d-flex align-items-center "
                >
                  <div
                    className="bg-primary rounded-circle d-flex"
                    style={{ paddingTop: "3px" }}
                  >
                    {profileList && profileList.length > 0
                      ? profileList[0].Username.charAt(0).toUpperCase()
                      : ""}
                    {/* <i className="ri-user-fill "></i> */}
                  </div>
                </a>

                <div class="iq-sub-dropdown iq-user-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0 ">
                      <div class="bg-primary pt-3">
                        <h5 class="mb-0 text-white line-height text-center ">
                          Hello{" "}
                          {profileList && profileList.length > 0
                            ? profileList[0].Username
                            : ""}
                        </h5>

                        <div
                          className="d-flex  justify-content-center"
                          style={{ marginTop: "-7px" }}
                        >
                          <span class="text-white font-size-12 text-center">
                            {profileList && profileList.length > 0
                              ? profileList[0].Role
                              : ""}
                          </span>
                        </div>
                      </div>
                      <a
                        href="/my-profile"
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-file-user-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">My Profile</h6>
                            <p class="mb-0 font-size-12">
                              View personal profile details.
                            </p>
                          </div>
                        </div>
                      </a>
                      <a
                        onClick={handleEditProfileModel}
                        style={{ cursor: "pointer" }}
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-profile-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0 ">Edit Profile</h6>
                            <p class="mb-0 font-size-12">
                              Modify your personal details.
                            </p>
                          </div>
                        </div>
                      </a>
                      <a
                        onClick={handleChangePassword}
                        style={{ cursor: "pointer" }}
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-account-box-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0 ">Change Password</h6>
                            <p class="mb-0 font-size-12">Modify your password.</p>
                          </div>
                        </div>
                      </a>

                      <div className="d-inline-block w-100 text-center p-3 col-md-12 text-white">
                        <button
                          className="bg-primary iq-sign-btn col-md-12"
                          onClick={() => handleSignOut()}
                          style={{ cursor: "pointer" }}
                          disabled={logoutLoading}
                        >
                          {
                            logoutLoading ? <span className="spinner-border spinner-border-sm mr-2" role="status"></span> :
                              <>
                                Sign out <i class="ri-login-box-line ml-2"></i>
                              </>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <Profile />
          </nav>
        </div>
        <Modal
          showModal={showJarStatusModal}
          title={"Update Bot Status"}
          onHide={closeNetworkModal}
          width={550}
          showFooter={false}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-md-12 mb-1 p-0 text-dark">
              {switchAction == true ? (
                <p>Are you sure, you want to stop Bot?</p>
              ) : (
                <p>Are you sure, you want to start Bot?</p>
              )}
            </div>
            <div className="text-right row my-2">
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={closeNetworkModal}
                >
                  Cancel
                </button>
                <Button
                  title={"Ok"}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                  loading={jarStatusLoading}
                />
              </div>
            </div>
          </form>
        </Modal>

        <Modal
          showModal={showISPJarStatusModal}
          title={"Update ISP Bot Status"}
          onHide={closeISPJarModal}
          width={550}
          showFooter={false}
        >
          <form onSubmit={handleISPSubmit(onISPSubmit)}>
            <div className="col-md-12 mb-1 p-0 text-dark">
              {switchISPAction == true ? (
                <p>Are you sure, you want to stop ISP Bot?</p>
              ) : (
                <p>Are you sure, you want to start ISP Bot?</p>
              )}
            </div>
            <div className="text-right row my-2">
              <div className="col-md-12">
                <button type="button" className="btn btn-secondary mr-2" onClick={closeISPJarModal} > Cancel </button>
                <Button title={"Ok"} buttonClass="btn btn-primary" buttonType="submit" loading={ispJarLoading} />
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
}

export default Header;